export default function replaceUserName(userName, initialString) {
  if (userName) {
    return initialString.replace(/<<USERNAME>>/g, userName);
  } else {
    return initialString.replace(/<<USERNAME>>/g, '');
  }
}
